import Vue from 'vue';
import _ from 'lodash';
import { db, docsFromSnapshot, docFromSnapshot } from '@/firebase';

const state = {
  packages: {}
};

const getters = {
  packagesList: state => _.sortBy(state.packages, 'name'),
  selectablePackagesList: state =>
    _.map(state.packages, _package => ({ id: _package.id })),
  packageById: state => id => state.packages[id]
};

const mutationTypes = {
  SET_PACKAGES: 'SET_PACKAGES',
  SET_PACKAGE: 'SET_PACKAGE',
  REMOVE_PACKAGE: 'REMOVE_PACKAGE'
};

const actions = {
  async createPackage(context, _package) {
    _package.storeId = context.rootGetters['stores/storeId'];
    _package.timestamp = +new Date();
    _package.created = +new Date();

    const ref = db.collection('packages').doc();
    _package._id = ref.id;

    await ref.set(_package);

    context.commit(mutationTypes.SET_PACKAGE, _package);
  },
  async fetchPackages(context) {
    const snap = await db
      .collection('packages')
      .where('storeId', '==', context.rootGetters['stores/storeId'])
      .get();

    context.commit(mutationTypes.SET_PACKAGES, docsFromSnapshot(snap));
  },
  async fetchPackage(context, id) {
    const snap = await db
      .collection('packages')
      .doc(id)
      .get();

    context.commit(mutationTypes.SET_PACKAGE, docFromSnapshot(snap));
  },
  async updatePackage(context, _package) {
    _package.timestamp = +new Date();

    await db
      .collection('packages')
      .doc(_package._id)
      .set(_package);

    context.commit(mutationTypes.SET_PACKAGE, _package);
  },
  async deletePackage(context, _package) {
    const referencingServices = _.filter(
      context.rootState['services/services'],
      service => service.packagesEnabled[_package._id]
    );

    if (referencingServices.length) {
      const referencingServiceIdsStr = _.map(referencingServices, 'name').join(
        ', '
      );
      throw {
        error: true,
        message: `Package ${_package.name} cannot be deleted as it is used in the following services: ${referencingServiceIdsStr}.`
      };
    }

    await db
      .collection('packages')
      .doc(_package._id)
      .delete();

    context.commit(mutationTypes.REMOVE_PACKAGE, _package._id);
  }
};

const mutations = {
  [mutationTypes.SET_PACKAGES](state, packages) {
    state.packages = packages;
  },
  [mutationTypes.SET_PACKAGE](state, _package) {
    state.packages = _.set(state.packages, _package._id, _package);
    Vue.set(state.packages, _package._id, _package);
  },
  [mutationTypes.REMOVE_PACKAGE](state, id) {
    state.packages = _.omit(state.packages, id);
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
